"use client";

import type {
  LeadFlowIconItem as LeadFlowIconItemContent,
  LeadFlowRichTextContent,
} from "@homeinstead/schemas";

import { cn } from "@homeinstead/ui";
import { IconItem } from "./IconItem";
import { RichTextItem } from "./RichTextItem";

const GRID_COLUMNS_CLASS: Record<number, string> = {
  1: "md:grid-cols-1",
  2: "md:grid-cols-2",
  3: "md:grid-cols-3",
  4: "md:grid-cols-4",
};

type ContentGridCellItem = {
  _key: string;
  _type: string;
  caption?: LeadFlowRichTextContent | null;
  customIconUrl?: string | null;
  icon?: LeadFlowIconItemContent["icon"] | null;
  text?: LeadFlowRichTextContent | null;
};

type ContentGridItemProps = {
  item: {
    columns?: Array<{
      _key: string;
      items?: ContentGridCellItem[] | null;
    }> | null;
  };
};

function ContentGridCell({ item }: { item: ContentGridCellItem }) {
  if (item._type === "leadFlowIconItem") {
    return <IconItem item={item} />;
  }

  if (item._type === "leadFlowRichText") {
    return <RichTextItem item={item} />;
  }

  return null;
}

function ContentGridItem({ item }: ContentGridItemProps) {
  const columns = item.columns ?? [];

  if (columns.length === 0) {
    return null;
  }

  return (
    <div
      className={cn(
        "grid grid-cols-1 gap-6",
        GRID_COLUMNS_CLASS[columns.length] ?? GRID_COLUMNS_CLASS[4],
      )}
    >
      {columns.map((column) => (
        <div className="flex flex-col gap-2" key={column._key}>
          {(column.items ?? []).map((cellItem) => (
            <ContentGridCell item={cellItem} key={cellItem._key} />
          ))}
        </div>
      ))}
    </div>
  );
}

export { ContentGridItem };
